import axiosClient from "utils/api";
const URI = "/admin/report";

export const getReportProblem = async (payload) => {
  const {type , ...rest}  = payload
  const URL = `${URI}/${type}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Get report problem:", error);
    throw error;
  }
};

export const updateReportProblem = async (payload) => {
  let { id, ...rest } = payload;

  const URL = `${URI}/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Update report problem:", error);
    throw error;
  }
};
